(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.selling-record', [
    'pp.widgets-templates',
    'pp.widgets.property-cell',
    'pp.components.table-sort',
    'pp.filters.numbers',
    'pp.services.route',
    'pp.services.property',
    'pp.services.core'
]);

ngModule.component('ppSellingRecord', {
    templateUrl: 'widgets/_angular/selling-record/selling-record.tpl.html',
    bindings: {
        propertiesDict: '<',
        holdings: '<',
        offers: '<',
        bids: '<',
        viewPropertyDetail: '&'
    },
    controllerAs: 'vm',
    controller: ['$scope', 'R', 'routeService', 'propertyService', function ($scope, R, routeService, propertyService) {
        var vm = this;

        // -- initial state

        vm.sortAttribute = '';
        vm.sortOrder = 'ascending';
        vm.loaded = false;

        var fiveYearUnitSaleData = [];

        // -- util functions

        function peformSort(attr, order) {
            var sort = R.sortBy(R.prop(attr));
            if (order === 'ascending') {
                return sort(fiveYearUnitSaleData);
            } else if (order === 'descending') {
                return R.compose(R.reverse, sort)(fiveYearUnitSaleData);
            } else {
                return R.clone(fiveYearUnitSaleData);
            }
        }

        function peformDateSort(attr, order) {
            var getDate = R.compose(function (a) {
                return new Date(a);
            }, R.prop(attr));
            var sort = R.sort(function (a, b) {
                var aDate = getDate(a).valueOf();
                var bDate = getDate(b).valueOf();
                return order === 'ascending' ? aDate - bDate : bDate - aDate;
            });
            return sort(fiveYearUnitSaleData);
        }

        function peformPropertySort(attr, order) {
            var sort = R.sort(function (a, b) {
                var aName = R.path([a.symbol, 'location', 'location1'], vm.propertiesDict);
                var bName = R.path([b.symbol, 'location', 'location1'], vm.propertiesDict);
                if (aName < bName) {
                    return order === 'ascending' ? -1 : 1;
                }

                if (bName < aName) {
                    return order === 'ascending' ? 1 : -1;
                }
                return 0;
            });
            return sort(fiveYearUnitSaleData);
        }

        var isNotNil = R.complement(R.isNil);

        function convertStringToDate(dateStr) {
            var parts = dateStr.split('/');
            var day = Number(parts[0]);
            var month = Number(parts[1]);
            var year = Number(parts[2]);

            // Unix timestamp in seconds
            return Math.floor(new Date(year, month - 1, day).getTime());
        }

        // -- api

        vm.updatePropertySort = function (attr, order) {
            vm.fiveYearUnitSaleData = peformPropertySort(attr, order);
            vm.sortOrder = order;
            vm.sortAttribute = attr;
        };

        vm.updateDateSort = function (attr, order) {
            vm.fiveYearUnitSaleData = peformDateSort(attr, order);
            vm.sortOrder = order;
            vm.sortAttribute = attr;
        };

        vm.updateSort = function (attr, order) {
            vm.fiveYearUnitSaleData = peformSort(attr, order);
            vm.sortOrder = order;
            vm.sortAttribute = attr;
        };

        vm.onViewPropertyDetail = function (property) {
            vm.viewPropertyDetail({
                property: property
            });
        };

        vm.getIndividualPropertyPath = routeService.getIndividualPropertyPath;

        // -- scope bindings

        vm.$onChanges = function (changes) {
            var properties = R.path(['propertiesDict', 'currentValue'], changes);
            if (R.isNil(properties) || vm.loaded) {
                // @Note early return
                return;
            }

            var propertiesToGet = Object.keys(properties).filter(function (symbol) {
                return !!R.path([symbol, 'isSecondaryMarketable'], properties);
            });

            propertyService.getBulkUnitDisclosure(propertiesToGet).then(function (res) {

                fiveYearUnitSaleData = R.flatten(res.map(function (property) {
                    var propertySymbol = property.disclosureTypePropertySymbol.replace('units_', '');
                    return property.units.filter(function (unit) {
                        return isNotNil(R.prop('salePrice', unit));
                    }).map(function (unit) {
                        return {
                            'symbol': propertySymbol,
                            'saleDate': convertStringToDate(unit.status),
                            'purchasePrice': unit.purchasePrice,
                            'ivValuation': unit.ivPrice,
                            'vpvValuation': unit.vpvPrice,
                            'salePrice': unit.salePrice
                        };
                    });
                }));

                vm.updateDateSort('saleDate', 'descending');

                vm.fiveYearUnitSaleTotal = {
                    purchasePrice: R.compose(R.sum, R.map(R.prop(['purchasePrice'])))(fiveYearUnitSaleData),
                    salePrice: R.compose(R.sum, R.map(R.prop(['salePrice'])))(fiveYearUnitSaleData),
                    ivValuation: R.compose(R.sum, R.map(R.prop(['ivValuation'])))(fiveYearUnitSaleData),
                    vpvValuation: R.compose(R.sum, R.map(R.prop(['vpvValuation'])))(fiveYearUnitSaleData)
                };
                vm.loaded = true;
            });
        };

        // -- main

    }]
});
})(window, window.angular);